var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15836_1007)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 0C9.45139 0 10.7899 0.357639 12.0156 1.07292C13.2413 1.78819 14.2118 2.75868 14.9271 3.98438C15.6424 5.21007 16 6.54861 16 8C16 9.45139 15.6424 10.7899 14.9271 12.0156C14.2118 13.2413 13.2413 14.2118 12.0156 14.9271C10.7899 15.6424 9.45139 16 8 16C6.54861 16 5.21007 15.6424 3.98438 14.9271C2.75868 14.2118 1.78819 13.2413 1.07292 12.0156C0.357639 10.7899 0 9.45139 0 8C0 6.54861 0.357639 5.21007 1.07292 3.98438C1.78819 2.75868 2.75868 1.78819 3.98438 1.07292C5.21007 0.357639 6.54861 0 8 0ZM9.33333 12.9896V11.0104C9.33333 10.9132 9.30208 10.8316 9.23958 10.7656C9.17708 10.6997 9.10069 10.6667 9.01042 10.6667H7.01042C6.92014 10.6667 6.84028 10.7014 6.77083 10.7708C6.70139 10.8403 6.66667 10.9201 6.66667 11.0104V12.9896C6.66667 13.0799 6.70139 13.1597 6.77083 13.2292C6.84028 13.2986 6.92014 13.3333 7.01042 13.3333H9.01042C9.10069 13.3333 9.17708 13.3003 9.23958 13.2344C9.30208 13.1684 9.33333 13.0868 9.33333 12.9896ZM9.3125 9.40625L9.5 2.9375C9.5 2.85417 9.46528 2.79167 9.39583 2.75C9.32639 2.69444 9.24306 2.66667 9.14583 2.66667H6.85417C6.75694 2.66667 6.67361 2.69444 6.60417 2.75C6.53472 2.79167 6.5 2.85417 6.5 2.9375L6.67708 9.40625C6.67708 9.47569 6.71181 9.53646 6.78125 9.58854C6.85069 9.64062 6.93403 9.66667 7.03125 9.66667H8.95833C9.05556 9.66667 9.13715 9.64062 9.20312 9.58854C9.2691 9.53646 9.30556 9.47569 9.3125 9.40625Z",
    fill: "#E56800"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15836_1007"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.d75d036f1a3999798ce186a5173a8905.svg";
export { ForwardRef as ReactComponent };